import {IMetaTag} from '@core/api/data-access';
import {IBaseStore} from '@global-data';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';

export const metaTagsAdapter: EntityAdapter<IMetaTag> = createEntityAdapter<IMetaTag>({
	selectId: (metaAG: IMetaTag) => {
		return metaAG?.key;
	},
});

export namespace MetaTagsStore {
	export type IMetaTagsState = IBaseStore & EntityState<IMetaTag> & object;

	export const metaTagsInitialState: IMetaTagsState = metaTagsAdapter.getInitialState({
		loading: false,
		loaded: false,
	});
}
